import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import { getTipoTermoDocumento, cadastrarTipoTermoDocumento, alterarTipoTermoDocumento, excluirTipoTermoDocumento } from '../../../api';
import { CadastroBasicoNomeSituacaoForm } from '../../../components/CadastroBasicoNomeSituacaoForm';
var TiposDocumentosEditar = function () {
    var services = {
        getItem: getTipoTermoDocumento,
        cadastrarItem: cadastrarTipoTermoDocumento,
        alterarItem: alterarTipoTermoDocumento,
        excluirItem: excluirTipoTermoDocumento,
    };
    return _jsx(CadastroBasicoNomeSituacaoForm, { pagina: PAGINAS.CC_TIPOS_TERMOS_DOCUMENTOS, paginaPermissao: FUNCIONALIDADES.CC_TIPOS_TERMOS_DOCUMENTOS, rota: ROUTES.CC_TIPOS_TERMOS_DOCUMENTOS, services: services });
};
export default TiposDocumentosEditar;
